import { useEffect } from 'react';
import { useProfileQuery, useExpertiseQuery } from '../api/query/useProfileQueries';
import { profileStore } from '../stores/profile.store';

export const useProfileData = ({ enabled = true } = {}) => {
  const {
    data: profileData,
    isLoading: isProfileLoading,
    isError: isProfileError,
  } = useProfileQuery({ enabled });

  const {
    data: expertiseData,
    isLoading: isExpertiseLoading,
    isError: isExpertiseError,
  } = useExpertiseQuery({ enabled });

  useEffect(() => {
    if (profileData) {
      profileStore.setProfile(profileData);
    }
  }, [profileData]);

  useEffect(() => {
    if (expertiseData) {
      const expertise = expertiseData?.data || expertiseData;
      profileStore.setExpertise(expertise);
    }
  }, [expertiseData]);

  useEffect(() => {
    profileStore.setProfileLoading(isProfileLoading);
  }, [isProfileLoading]);

  useEffect(() => {
    profileStore.setExpertiseLoading(isExpertiseLoading);
  }, [isExpertiseLoading]);

  return {
    isProfileLoading,
    isExpertiseLoading,
    hasProfileError: isProfileError || isExpertiseError,
  };
};
